export default __webpack_public_path__ + "static/media/no.0ae96aa6.PNG";